import { useState } from "react";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

import CustomInput from "../../../common/CustomInput";
import CustomLoader from "../../../common/CustomLoader";
import { validations } from "../../../constants";
import { apiCallV2 } from "../../../utils/api";
import { delay } from "../../../utils";
import { CallImpactConversion } from "../../../redux/v2/impact/actions";
import { SetUserDetails } from "../../../redux/v2/user/actions";
import { FillEye, FillEyeSlash } from "../../../common/CustomIcons";
import CustomButton from "../../../common/CustomButton";
import CustomActionButton from "../../../common/CustomActionButton";

const StepOne = (props) => {
    const token = new URLSearchParams(window.location.search).get("token");
    const sale = new URLSearchParams(window.location.search).get("sale-id") || localStorage.getItem("sale-id");

    const userInitialData = JSON.parse(localStorage.getItem(token));

    let launchDate = localStorage.getItem("launchDate");
    launchDate = new Date(launchDate);
    const navigate = useNavigate();

    const { account } = props.User;

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [email, setEmail] = useState(token ? userInitialData?.email_address.trim(" ") : "");
    const [emailAddress, setEmailAddress] = useState(""); //h-p
    const [fullName, setFullName] = useState(""); //h-p

    const [error, setErrorMessage] = useState("");
    const [emailError, setEmailErrorMessage] = useState("");
    const [passwordError, setpasswordError] = useState("");
    const [confirmpasswordError, setconfirmpasswordError] = useState("");
    //  const [loading, setLoading] = useState(false);

    const [isVisible, setIsVisible] = useState(false);
    const [isVisibleSecond, setIsVisibleSecond] = useState(false);

    const isBot = (fields) => {
        let bool = false;

        for (let x = 0; x < fields.length; x++) {
            if (fields[x]) {
                bool = true;
                break;
            }
        }
        return bool;
    };

    const onChangeEmail = (event) => {
        setEmail(event.target.value);
        if (email == "") {
            setEmailErrorMessage("");
        }
        if (emailError != "" && validations.emailRegex.test(email)) {
            setEmailErrorMessage("");
        }
    };

    const onChangePassword = (event) => {
        setPassword(event.target.value);
        if (password == "") {
            setpasswordError("");
        }
        if (passwordError != "" && validations.passwordRegex.test(password)) {
            setpasswordError("");
        }
    };

    const onChangeConfirmPassword = (event) => {
        setConfirmPassword(event.target.value);
        if (confirmPassword == "") {
            setconfirmpasswordError("");
        }
        if (confirmpasswordError != "" && validations.passwordRegex.test(confirmPassword)) {
            setconfirmpasswordError("");
        }
    };

    const onBlurEmailInput = async (e) => {
        e.preventDefault();
        if (email.trim() == "") {
            setEmailErrorMessage(validations.emailValidation);
        } else if (!validations.emailRegex.test(email)) {
            setEmailErrorMessage(validations.emailRegexValidation);
        } else {
            setErrorMessage("");
            setEmailErrorMessage("");
            const res = await apiCallV2("POST", "check-email", {
                email_address: email,
            });
            if (res.data.status == 200) {
                localStorage.setItem("email", email);
            } else if (res.data.status == 409) {
                setEmailErrorMessage("Email already exists");
            } else {
                setEmailErrorMessage(res.data.message);
            }
        }
    };

    const onClickSignup = async (e) => {
        if (isBot([emailAddress, fullName])) return;

        if (email.trim() == "") {
            setEmailErrorMessage(validations.emailValidation);
        } else if (!validations.emailRegex.test(email)) {
            setEmailErrorMessage(validations.emailRegexValidation);
        } else if (password == "") {
            setpasswordError(validations.passwordValidation);
        } else if (confirmPassword == "") {
            setconfirmpasswordError(validations.passwordValidation);
        } else if (!validations.passwordRegex.test(password)) {
            setpasswordError(validations.passwordRegexValidation);
        } else if (confirmPassword != "" && password !== confirmPassword) {
            setconfirmpasswordError(validations.passwordMatchValidation);
        } else {
            setErrorMessage("");
            setpasswordError("");
            setEmailErrorMessage("");
            setconfirmpasswordError("");

            const irclickid = localStorage.getItem("irclickid");

            const res = await apiCallV2("POST", "signup", {
                email_address: email,
                user_type: 2, //1 is customer,0 is admin
                password: password,
                emailAddress: emailAddress,
                fullName: fullName,
            });

            if (res.data.status == 200) {
                props.SetUserDetails({
                    email_address: email,
                });

                if (irclickid) {
                    props.CallImpactConversion(irclickid, res.data.data.access_token, email);
                }

                localStorage.setItem("access-token", res.data.data.access_token);
                localStorage.setItem("requirement_status", 0);

                navigate("/personal-info");
                return true;
                // if (sale) {
                //    navigate(`/choose-plan-sale?sale-id=${sale}`);
                // } else {
                //    navigate("/choose-plan");
                // }
            } else {
                setErrorMessage(res.data.message);
                return false;
            }
        }
    };

    const onClickSignupCompanyUser = async () => {
        if (isBot([emailAddress, fullName])) return;

        if (password == "") {
            setpasswordError(validations.passwordValidation);
        } else if (confirmPassword == "") {
            setconfirmpasswordError(validations.passwordValidation);
        } else if (!validations.passwordRegex.test(password)) {
            setpasswordError(validations.passwordRegexValidation);
        } else if (confirmPassword != "" && password !== confirmPassword) {
            setconfirmpasswordError(validations.passwordMatchValidation);
        } else {
            setErrorMessage("");
            setpasswordError("");
            setconfirmpasswordError("");
            const res = await apiCallV2(
                "POST",
                "continue-signup",
                {
                    email_address: email,
                    user_name: email,
                    password: password,
                    id: userInitialData.id,
                },
                token
            );
            if (res.data.status == 200) {
                props.SetUserDetails({
                    ...account?.user,
                    email_address: email,
                });

                localStorage.setItem("access-token", token);
                localStorage.setItem("requirement_status", 1);

                toast.success("Plan subscribed successfully");

                delay(() => {
                    navigate("/personal-info");
                }, 1000);

                return true;
            } else {
                setErrorMessage(res.data.message);
                return false;
            }
        }
    };

    return (
        <>
            <div>
                {token ? (
                    <h3
                        style={{
                            marginTop: "-25px",
                            marginBottom: "25px",
                        }}
                    >
                        Create a password
                    </h3>
                ) : (
                    <h2 className="ta-l">SIGN UP</h2>
                )}
                <form
                    onSubmit={() => {
                        return false;
                    }}
                >
                    {/* ====================== EMAIL (OPEN) ====================== */}
                    {!token && (
                        <div className="form-group">
                            <div className="d-flex align-items-center">
                                <CustomInput
                                    placeholder="EMAIL"
                                    onBlur={(e) => {
                                        onBlurEmailInput(e);
                                    }}
                                    type="text"
                                    className="i-box"
                                    style={{
                                        width: "100%",
                                        borderColor: emailError == "" || emailError == undefined ? "lightgrey" : "red",
                                    }}
                                    value={email}
                                    name="email"
                                    onChange={(event) => onChangeEmail(event)}
                                />
                            </div>
                            {emailError != "" && <p className="error">{emailError}</p>}
                        </div>
                    )}
                    {/* ====================== EMAIL (CLOSE) ====================== */}

                    {/* ====================== PASSWORD (OPEN) ====================== */}
                    <div className="form-group">
                        <div className="d-flex align-items-center">
                            {/* <label>Password</label> */}
                            <div className="position-relative i-box" style={{ width: "100%" }}>
                                <CustomInput
                                    placeholder="PASSWORD"
                                    autoComplete="new-password"
                                    style={{
                                        width: "100%",
                                        borderColor: passwordError == "" ? "lightgrey" : "red",
                                    }}
                                    value={password}
                                    name="password"
                                    onChange={(event) => onChangePassword(event)}
                                    // className="i-box"
                                    type={isVisible ? "text" : "password"}
                                />
                                <button onClick={() => setIsVisible(!isVisible)} type="button" className="btn btn-light icon-right">
                                    {isVisible ? <FillEye /> : <FillEyeSlash />}
                                </button>
                            </div>
                        </div>

                        {passwordError != "" && <p className="error">{passwordError}</p>}
                    </div>
                    {/* ====================== PASSWORD (CLOSE) ====================== */}

                    {/* ====================== CONFIRM PASSWORD (OPEN) ====================== */}
                    <div className="form-group">
                        <div className="d-flex align-items-center">
                            {/* <label>Password</label> */}
                            <div className="position-relative i-box" style={{ width: "100%" }}>
                                <CustomInput
                                    placeholder="CONFIRM PASSWORD"
                                    autoComplete="new-password"
                                    value={confirmPassword}
                                    style={{
                                        borderColor: confirmpasswordError == "" ? "lightgrey" : "red",
                                    }}
                                    name="confirmPassword"
                                    onChange={(event) => onChangeConfirmPassword(event)}
                                    type={isVisibleSecond ? "text" : "password"}
                                />
                                <button onClick={() => setIsVisibleSecond(!isVisibleSecond)} type="button" className="btn btn-light icon-right">
                                    {isVisibleSecond ? <FillEye /> : <FillEyeSlash />}
                                </button>
                            </div>
                        </div>
                        {confirmpasswordError != "" && <p className="error">{confirmpasswordError}</p>}
                    </div>
                    {/* ====================== CONFIRM PASSWORD (CLOSE) ====================== */}

                    {/* ====================== HP (OPEN) ====================== */}
                    <div className="form-group">
                        <div
                            className="d-sm-flex align-items-center" //HONEY-P
                            style={{
                                position: "absolute",
                                top: "-99999px",
                            }}
                        >
                            <label className="text-sm-right drop-m">Email Confirm</label>
                            <CustomInput type="text" value={emailAddress} name="email_confirm" onChange={(event) => setEmailAddress(event.target.value)} className="i-box" />
                        </div>

                        <div
                            className="d-sm-flex align-items-center" //HONEY-P
                            style={{
                                position: "absolute",
                                top: "-99999px",
                            }}
                        >
                            <label className="text-sm-right drop-m">Full Name</label>
                            <CustomInput type="text" value={fullName} name="full_name" onChange={(event) => setFullName(event.target.value)} className="i-box" />
                        </div>
                    </div>
                    {/* ====================== HP (CLOSE) ====================== */}

                    <div className="text-center" style={{ margin: "10px 0", padding: "20px 0" }}>
                        <CustomActionButton
                            disabled={error || emailError}
                            action={async () => {
                                if (!token) {
                                    return await onClickSignup();
                                } else {
                                    return await onClickSignupCompanyUser();
                                }
                            }}
                            type={2}
                        >
                            Continue
                        </CustomActionButton>
                    </div>

                    <h5 className="e-text reset-link">
                        Already have an account? <Link to={"/login"}>Login</Link>.
                    </h5>

                    {/* {loading && <CustomLoader loading={loading} />} */}
                </form>
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {
    CallImpactConversion,
    SetUserDetails,
})(StepOne);
